import { render, staticRenderFns } from "./AboutEdit.vue?vue&type=template&id=5344de3f&"
import script from "./AboutEdit.vue?vue&type=script&lang=js&"
export * from "./AboutEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports